import http from "../../http";

const orderBillV2 = {
  /** 运营商业务对账 V2（实时，独立于旧 queryBillData） */
  queryForAgent(r) {
    return http.spin.get("/gateway/api/sycompany/pc/OrderCenterBillV2PC/queryForAgent", r);
  },
  /** 店铺业务对账 V2 */
  queryForCompany(r) {
    return http.spin.get("/gateway/api/sycompany/pc/OrderCenterBillV2PC/queryForCompany", r);
  },
  /** 运营商订单合并服务端导出（返回预签名下载地址） */
  exportOrderMergeForAgent(r) {
    return http.spin.get("/gateway/api/sycompany/pc/OrderCenterBillV2PC/exportOrderMergeForAgent", r);
  },
};

export default orderBillV2;
